import React, {FC} from 'react'
import {PageTitle} from '@/_metronic/layout/core'
import {TableWrapper} from '@/components/table/TableWrapper'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder'
import {ModalWrapperProps} from '@/components/table/core/_types'
import {Modal} from '@/components/table/modal/Modal'
import {getTransactions} from '../core/_requests'
import {Columns} from './columns/_columns'
import {FilterForm, initialFilters} from './components/FilterForm'
import {TrxOverview} from './components/Overview'

const Breadcrumbs = BreadcrumbsBuilder([{
  title: 'Home',
  path: '/'
}, {
  title: 'Passtocard',
  path: '/p2c/dashboard',
}])

const ModalWrapper: FC<ModalWrapperProps> = ({itemForUpdate, action}) => {
  return (
    <>
      {itemForUpdate !== undefined && action === 'details' && (
        <Modal title="Transaction details" maxWidth={800}>
          <TrxOverview/>
        </Modal>
      )}
    </>
  )
}


const ListWrapper = () => (
  <>
    <PageTitle breadcrumbs={Breadcrumbs}>Transactions</PageTitle>
    <TableWrapper
      dataProvider={getTransactions}
      cols={Columns}
      queryId="P2C_TRANSACTION_LIST"
      modals={ModalWrapper}
      lookup={{
        placeholder: 'Search transaction',
        fields: ['Email', 'Username', 'Code', 'Msisdn']
      }}
      filters={{
        formFields: FilterForm,
        initialValues: initialFilters
      }}
    />
  </>
)

export default ListWrapper
